// ** React Imports
import { useHistory } from "react-router-dom";

// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";
import { ButtonRounded } from "components/layout/Button/ButtonRounded";
import LightEye from "components/icons/LightEye";

// #####################################################

export const StyledBlock = styled(Block)`
	display: flex;
	position: absolute;
	right: 1rem;
	margin-top: 1rem;

	${({ isActive }) =>
		isActive &&
		css`
			svg {
				color: ${({ theme: { colors, isDarkMode } }) =>
					isDarkMode
						? colors.primaryLight
						: "var(--dz-ref-color-primary400)"};
			}
		`}

	${({ isGrid }) =>
		isGrid &&
		css`
			position: absolute;
			top: 0.25rem;
			right: 0.25rem;
			z-index: 1;
		`}
`;

const FollowersButtonNotAuth = () => {
	const history = useHistory();

	const BtnComponent = (
		<ButtonRounded
			noPointerEffect
			active
			addBorder
			key={`followers-key`}
			squared
			disabled={false}
			onClick={(event) => {
				event.preventDefault();

				history.push("/");
				window.scrollTo(0, 0);
			}}
		>
			<LightEye height={"14px"} />
		</ButtonRounded>
	);

	// #####################################################

	return <StyledBlock flex>{BtnComponent}</StyledBlock>;
};

// #####################################################

export default FollowersButtonNotAuth;

// #####################################################
